import React from "react";
import Backdrop from "@material-ui/core/Backdrop";
import { makeStyles } from "@material-ui/core/styles";
const useStyles = makeStyles(theme => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff"
  }
}));

function OverlayBackdrop({
  open,
  spinner
}) {
  const classes = useStyles();
  return /*#__PURE__*/React.createElement(Backdrop, {
    className: classes.backdrop,
    open: open
  }, spinner());
}

OverlayBackdrop.defaultProps = {
  open: false
};
export default OverlayBackdrop;